module.exports = __webpack_public_path__ + "static/media/masthead-great-southern-herald.a8373d10.svg";